import { createApp } from "vue";
import "reflect-metadata";
import "core-js/stable";
import "regenerator-runtime/runtime";
import I18n from "./i18n";

//Vue.config.devtools = true;
import mainstore, { key } from "./store";

import quasar from "./quasar";
import Axios from "axios";
import App from "./App.vue";
import router from "./router";
import Sentry from "./sentry";

import mitt from "mitt"; // Import mitt
const emitter = mitt(); // Initialize mitt

import titleMixin from "./mixins/titleMixin";
//import MockAdapter from "axios-mock-adapter";

/* if (process.env.VITE_VUE_APP_MOCKDATA === "true") {
  const Mocks = require("./mocks").default;
  const mock = new MockAdapter(Axios, { onNoMatch: "throwException" });
  Mocks.install(mock);
} */

import ISTcomponentsIndex from "./components/ISTcomponentsIndex";
import { IstComponents } from "@ist/brdk_uigruppe";
import "@ist/brdk_uigruppe/dist/style.css";
import modal from "./components/modal";
import "./assets/ist-style.min.css";
import "./assets/ida-style.scss";
import "./assets/animate.css";
import "quasar/src/css/index.sass";
import "./assets/quasar.scss";
import "./assets/ist-cutegrids.css";
import VueMatomo from "vue-matomo";
import { QueryClient, VueQueryPlugin, VueQueryPluginOptions } from "@tanstack/vue-query";
import { initializeQueryInvalidation } from "./utils/queryInvalidation";

// eslint-disable-next-line space-before-function-paren
Date.prototype.toJSON = function (): string {
  return new Date(this.getTime() - this.getTimezoneOffset() * 60000).toISOString().replace("Z", "");
};

// Modify your Vue Query global settings here
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } }
});
const options: VueQueryPluginOptions = { queryClient };

// Initialize query invalidation utilities
initializeQueryInvalidation(queryClient);

const app = createApp(App)
  .use(I18n)
  .use(ISTcomponentsIndex)
  .use(IstComponents)
  .use(mainstore, key)
  .use(modal)
  .use(router)
  .use(quasar)
  .use(VueQueryPlugin, options)
  .mixin(titleMixin);

app.config.globalProperties.$http = Axios;
app.config.globalProperties.$router = router;
app.config.performance = mainstore.state.mainConfig.ENVIRONMENTNAME === "Development";
app.provide("$mainstore", mainstore);
app.provide("emitter", emitter);

app.use(VueMatomo, {
  host: "https://matomo.ist.com",
  siteId: 26,
  router: router,
  enableLinkTracking: true,
  trackPageView: true
});

const localLogToSentry = false; // Ændres til true, hvis du har behov for at logge lokalt
app.use(Sentry, router);
app.mount("#app");

mainstore.dispatch("GetConfig").then(() => {
  const props = router.resolve({
    name: "home"
  });
  mainstore.dispatch("security/setLogoutUrl", new URL(props.href, window.location.href || "").href);
});
